import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const WfhNavBarItems = () => {
  const location = useLocation();
  const DynamicMenu = JSON.parse(
    localStorage.getItem("DynamicMenuJson" || "{}")
  );
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [dynamicMenuList, setDynamicMenuList] = useState({});
  const [featureConfig, setFeatureConfig] = useState({});
  // const featureConfig = {
  //   "WH-008": { route: "/Calendar", defaultIcon: "/images/menu-icon/DashboardIcon.svg" },
  //   "WH-001": { route: "/WfhDashboard", defaultIcon: "/images/menu-icon/DashboardIcon.svg" },
  //   "WH-002": { route: "/MyWfh", defaultIcon: "/images/org-img/leave/my-leave.svg" },
  //   "WH-003": { route: "/TeamWfh", defaultIcon: "/images/menu-icon/org-leaves.svg" },
  //   "WH-004": { route: "/ledger", defaultIcon: "/images/org-img/leave/team-leaves.svg" },
  //   "WH-005": { route: "/WfhApplyForOther", defaultIcon: "/images/menu-icon/ledger.svg" },
  //   "WH-006": { route: "/WFHAdjustment", defaultIcon: "/images/org-img/leave/apply-forother.svg" },
  // };
  const moreFeatures = ["WH-004", "WH-005", "WH-006"];

  useEffect(() => {
    if (DynamicMenu?.EmployeeFunctionalityGroups?.length > 0) {
      setDynamicMenuList(
        DynamicMenu?.EmployeeFunctionalityGroups?.find(
          (WFH) => WFH?.Code == "WH"
        )
      );
    }
    // if (userDetails?.DirectReporteeCount != 0) {
    //   setFeatureConfig({
    //     "WH-008": { route: "/Calendar", defaultIcon: "/images/menu-icon/DashboardIcon.svg" },
    //     "WH-001": { route: "/WfhDashboard", defaultIcon: "/images/menu-icon/DashboardIcon.svg" },
    //     "WH-002": { route: "/MyWfh", defaultIcon: "/images/org-img/leave/my-leave.svg" },
    //     "WH-003": { route: "/TeamWfh", defaultIcon: "/images/menu-icon/org-leaves.svg" },
    //     "WH-004": { route: "/ledger", defaultIcon: "/images/org-img/leave/team-leaves.svg" },
    //     "WH-005": { route: "/WfhApplyForOther", defaultIcon: "/images/menu-icon/ledger.svg" },
    //     "WH-006": { route: "/WFHAdjustment", defaultIcon: "/images/org-img/leave/apply-forother.svg" },
    //   });
    // } else {
    //   setFeatureConfig({    "WH-008": { route: "/Calendar", defaultIcon: "/images/menu-icon/DashboardIcon.svg" },
    // "WH-001": { route: "/WfhDashboard", defaultIcon: "/images/menu-icon/DashboardIcon.svg" },
    // "WH-002": { route: "/MyWfh", defaultIcon: "/images/org-img/leave/my-leave.svg" },
    // // "WH-003": { route: "/TeamWfh", defaultIcon: "/images/menu-icon/org-leaves.svg" },
    // "WH-004": { route: "/ledger", defaultIcon: "/images/org-img/leave/team-leaves.svg" },
    // // "WH-005": { route: "/WfhApplyForOther", defaultIcon: "/images/menu-icon/ledger.svg" },
    // "WH-006": { route: "/WFHAdjustment", defaultIcon: "/images/org-img/leave/apply-forother.svg" },
    //   });
    // }

    const baseConfig = {
      "LV-008": {
        route: "/WFHDashboard/Calendar",
        defaultIcon: "/images/menu-icon/DashboardIcon.svg",
      },
      "WH-001": {
        route: "/WfhDashboard",
        defaultIcon: "/images/menu-icon/DashboardIcon.svg",
      },
      "WH-002": {
        route: "/MyWfh",
        defaultIcon: "/images/org-img/leave/my-leave.svg",
      },
      "WH-004": {
        route: "/ledger",
        defaultIcon: "/images/org-img/leave/team-leaves.svg",
      },
    };

    const extraConfig = {
      "WH-003": {
        route: "/TeamWfh",
        defaultIcon: "/images/menu-icon/org-leaves.svg",
      },
      "WH-005": {
        route: "/WfhApplyForOther",
        defaultIcon: "/images/menu-icon/ledger.svg",
      },
      "WH-006": {
        route: "/WFHAdjustment",
        defaultIcon: "/images/org-img/leave/apply-forother.svg",
      },
    };

    if (userDetails?.DirectReporteeCount != 0) {
      setFeatureConfig({ ...baseConfig, ...extraConfig });
    } else {
      setFeatureConfig(baseConfig);
    }
  }, []);

  return (
    <div>
      <div className="rightside-tabs">
        {dynamicMenuList?.EmployeeFunctionalityList?.map((timeOff, index) => {
          const config = featureConfig[timeOff.Code];
          const isActive = location?.pathname === config?.route;
          if (moreFeatures.includes(timeOff.Code)) {
            return null;
          }

          if (config) {
            return (
              <div className="me-auto" key={index}>
                <Link to={config.route}>
                  <h2
                    className={`font-w600 mb-0 ${isActive ? "h2active" : ""}`}
                  >
                    <img
                      src={timeOff?.IconPath || config.defaultIcon}
                      style={{ backgroundColor: timeOff?.Color }}
                    />
                    {timeOff?.FeatureName}
                  </h2>
                </Link>
              </div>
            );
          }
          return null;
        })}

        <div className="me-auto">
          <ul style={{ cursor: "pointer" }}>
            <li
              className="nav-item dropdown notification_dropdown"
              title="More"
            >
              <a
                className="nav-link p-0 moremenudropdown"
                data-bs-toggle="dropdown"
              >
                <img
                  src="/images/menu-icon/MoreIcon.svg"
                  style={{ width: "16px", marginRight: "6px" }}
                />
                More
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                <ul className="timeline">
                  {dynamicMenuList?.EmployeeFunctionalityList?.map(
                    (timeOff, index) => {
                      const config = featureConfig[timeOff.Code];
                      const isActive = location?.pathname === config?.route;

                      if (moreFeatures.includes(timeOff.Code) && config) {
                        return (
                          <li className="mb-0" key={index}>
                            <Link
                              to={config.route}
                              className={`timeline-panel  d-inline-flex profiledrop2 p-0 ${
                                isActive ? "h2active" : ""
                              }`}
                            >
                              <img
                                src={timeOff?.IconPath || config.defaultIcon}
                              />
                              {timeOff?.FeatureName}
                            </Link>
                          </li>
                        );
                      }
                      return null;
                    }
                  )}
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WfhNavBarItems;
